export function Button({ as, href, type = 'button', variant = 'neutral', size = 'md', className = '', children, ...props }) {
  const base = 'btn-pushable inline-flex items-center justify-center gap-2 font-extrabold transition-all disabled:opacity-50 disabled:cursor-not-allowed'

  const sizes = {
    sm: 'px-3 py-2 rounded-2xl text-sm',
    md: 'px-4 py-2.5 rounded-2xl text-sm',
    lg: 'px-5 py-3 rounded-2xl text-sm',
  }

  const variants = {
    primary:
      'bg-brand-pink text-white border-2 border-brand-textDark shadow-[4px_4px_0px_0px_#E04848] hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-none',
    secondary:
      'bg-brand-yellow text-brand-textDark border-2 border-brand-textDark shadow-[4px_4px_0px_0px_#E5BC2E] hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-none',
    neutral:
      'bg-white dark:bg-slate-950 text-brand-textDark dark:text-slate-100 border-2 border-brand-textDark dark:border-slate-700 shadow-[4px_4px_0px_0px_#CBD5E1] hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-none',
    danger:
      'bg-brand-pink text-white border-2 border-brand-textDark shadow-[4px_4px_0px_0px_#E04848] hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-none',
  }

  const cls = `${base} ${sizes[size] || sizes.md} ${variants[variant] || variants.neutral} ${className}`.trim()

  if (as === 'a' || typeof href === 'string') {
    return (
      <a href={href} className={cls} {...props}>
        {children}
      </a>
    )
  }

  return (
    <button type={type} className={cls} {...props}>
      {children}
    </button>
  )
}
